module.exports = __webpack_public_path__ + "img/logo-bhc.b3564c08.png";